import request from "../utils/request";

export function deleteOrder(id) {
    return request({
        url: `/order/${id}`,
        method: 'delete'
    })
}

export function getOrderById(id) {
    return request({
        url: `/order/${id}`,
        method: 'get'
    })
}

export function createOrder(data) {
    return request({
        url: `/order`,
        method: 'post',
        data
    })
}

export function updateOrder(data) {
    return request({
        url: `/order`,
        method: 'put',
        data
    })
}

export function confirm(id) {
    return request({
        url: `/order/confirm`,
        method: 'put',
        params:{orderId:id},
    })
}

export function getOrderPage(data,pageNum,pageSize) {
    return request({
        url: `/order/findManagePage`,
        method: 'post',
        params:{pageNum,pageSize},
        data
    })
}
